import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ArticleContent() {
    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    {/* H1 */}
                    <MKTypography variant="h1" component="h2" mb={3} color="dark">
                        Curățenie comercială pentru magazine și galerii
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Într-o zi ploioasă, urmele apar primele la intrare. Se văd pe pardoseală, în
                        fața vitrinei, în zona caselor de marcat. Dacă administrezi un astfel de
                        spațiu, știi deja cât de repede se schimbă aspectul lui într-o zi
                        aglomerată.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Doral Cleaning se ocupă de întreținerea magazinelor, showroomurilor,
                        galeriilor și a altor spații cu trafic mare. Ne uităm la cum circulă oamenii
                        prin locație, ce suprafețe se murdăresc repede și în ce intervale apar cele
                        mai multe probleme. De aici pornim când stabilim cum lucrăm.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/BVNjQBYP/Curatenie-spatii-comerciale.jpg"
                        alt="Curățenie comercială pentru magazine și galerii cu trafic intens"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={3} color="dark">
                        Ce înseamnă curățenia comercială pentru magazine și galerii
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        În retail, curățenia nu seamănă cu cea dintr-un birou. La intrare se adună
                        apă și praf. Pe sticlă rămân amprente. În jurul caselor de marcat apar urme
                        repede. În cabinele de probă și în grupurile sanitare trebuie verificat
                        constant. Sunt multe puncte mici, dar ele schimbă imediat felul în care
                        arată tot spațiul.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        De aceea, întreținerea unui astfel de loc nu merge făcută din când în când,
                        la grămadă. Are nevoie de ordine în lucru și de atenție la zonele care se
                        degradează vizual primele. Într-un showroom contează mult detaliul. Într-o
                        galerie contează și ritmul. Într-un magazin stradal contează mult ce poate
                        fi făcut înainte de deschidere și ce rămâne pentru finalul zilei.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        La Doral Cleaning, nu pornim de la un pachet standard. Mai întâi vedem
                        spațiul. Apoi decidem ce trebuie făcut des, ce intră în întreținerea
                        periodică și ce merită tratat separat.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/ycvDjm7y/Ce-inseamna-curatenia-in-spatii-comerciale.jpg"
                        alt="Ce înseamnă curățenie comercială pentru magazine și galerii comerciale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Ce tipuri de spații sunt incluse în serviciile de curățenie comercială
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Putem interveni în magazine stradale, spații din centre comerciale, galerii,
                        showroom-uri, recepții, holuri, cabine de probă, grupuri sanitare, zone de
                        acces și alte spații folosite zilnic de clienți și personal. Lucrăm atât
                        pentru o singură locație, cât și pentru mai multe puncte de lucru.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Diferența dintre curățenia comercială și curățenia obișnuită
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Diferența se vede repede. Într-un spațiu comercial, nu ajunge să fie curat
                        dimineața. Trebuie să se mențină bine și după ce încep să intre oamenii.
                        Asta cere alt ritm de lucru, alte verificări și mai multă atenție la zonele
                        care se murdăresc primele.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Clientul nu stă să analizeze un spațiu. Intră și își face o părere în câteva
                        secunde. Se uită la intrare, la pardoseală, la sticlă, la zona de vânzare.
                        Dacă vede urme, praf sau colțuri neglijate, tot locul pare mai puțin
                        îngrijit.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Și pentru echipa din locație contează. Un{" "}
                        <a
                            href="https://doral-cleaning.ro/curatenie-de-intretinere"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            spațiu ținut curat
                        </a>{" "}
                        este mai ușor de administrat. Murdăria nu se adună în straturi. Suprafețele
                        se păstrează mai bine. Iar problemele se văd din timp, nu după ce încep să
                        sară în ochi.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        În zonele cu trafic mare, diferența se simte repede. Mai ales la intrare, pe
                        traseul principal și în grupurile sanitare.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/3YvdRjhn/Importan-a-cur-eniei-profesionale-n-spa-ii-comerciale-i-magazine.jpg"
                        alt="Importanța curățeniei profesionale în spații comerciale și magazine"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} mt={2} color="dark">
                        De ce este importantă curățenia profesională în spațiile comerciale
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Prima impresie contează pentru clienții din retail
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        În retail, prima impresie nu vine doar din produse sau din amenajare. Vine
                        și din cum arată spațiul. O intrare curată, o vitrină fără urme și o
                        pardoseală bine întreținută schimbă imediat felul în care este perceput
                        locul.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Igienă, siguranță și conformitate în zonele cu trafic intens
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Apa, praful și urmele se mută repede dintr-o zonă în alta. De aceea, anumite
                        puncte trebuie urmărite mai atent. O întreținere făcută la timp ajută la
                        păstrarea ordinii și reduce disconfortul pentru clienți și angajați.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Serviciile se stabilesc după ce vedem locația și înțelegem cum funcționează
                        în realitate. Unele spații au vitrine mari și pardoseli pe care se vede
                        imediat orice urmă. Altele au cea mai mare presiune în zona de acces și în
                        jurul caselor de marcat. În alte cazuri, cabinele de probă și grupurile
                        sanitare cer mai multă atenție decât restul suprafeței.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Pentru pardoselile rezistente la trafic intens putem folosi mașini de
                        frecat-aspirat. Pentru praf fin și reziduuri folosim aspiratoare
                        profesionale. Lucrăm separat pe zone și folosim lavete diferențiate pe
                        culori, tocmai ca să nu mutăm murdăria dintr-un loc în altul. Pentru anumite
                        suprafețe pe care praful se așază repede putem folosi și soluții
                        antistatice. La vitrine și geamuri contează altceva: să nu rămână dâre și
                        urme care se văd imediat în lumină.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        În perioadele aglomerate, lucrurile se schimbă. În timpul reducerilor sau
                        înainte de sărbători, o intervenție de seară poate să nu mai fie suficientă.
                        Atunci completăm cu o verificare scurtă dimineața sau acordăm prioritate
                        zonei de intrare și traseului principal. Acolo apar primele semne că spațiul
                        a fost pus la încercare.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/BkTHpcW/Servicii-curatare-retail.jpg"
                        alt="Servicii de curățenie comercială pentru magazine și galerii comerciale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} mt={2} color="dark">
                        Ce includ serviciile noastre de curățenie pe zona comercială
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățarea pardoselilor, suprafețelor și zonelor de acces
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        La intrare se vede cel mai repede. De aceea, pardoselile și zonele de acces
                        cer atenție constantă.{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-pardoseli"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            Curățăm aceste suprafețe
                        </a>{" "}
                        în funcție de material, gradul de uzură și volumul de trafic. Ne ocupăm și
                        de tejghele, polițe, zone de plată, mânere, uși și alte puncte unde urmele
                        apar repede.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Curățarea geamurilor, vitrinelor și suprafețelor vitrate
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Vitrina este printre primele lucruri observate de client. Dacă are amprente,
                        urme sau praf în colțuri, întregul spațiu pare mai puțin îngrijit.{" "}
                        <a
                            href="https://doral-cleaning.ro/curatare-geamuri-suprafete-vitrate"
                            style={{ color: "#1a73e8", textDecoration: "underline" }}
                        >
                            Curățăm vitrinele
                        </a>
                        , geamurile și alte suprafețe vitrate periodic sau separat, în funcție de ce
                        are nevoie locația.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Igienizarea grupurilor sanitare și a zonelor comune
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Grupurile sanitare și zonele comune spun repede cât de atent este întreținut
                        spațiul. Aici se vede imediat dacă lucrurile sunt ținute sub control sau
                        lăsate să se adune. Curățăm aceste zone cu atenție la suprafețele folosite
                        frecvent, la completarea consumabilelor și la aspectul real al spațiului.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Fiecare locație are ritmul ei. În unele zile este mai liber dimineața și mai
                        aglomerat spre seară. În altele, vârful începe de la deschidere. În
                        perioadele de promoții, de schimbare de sezon sau de sărbători, anumite zone
                        ajung să arate obosit mult mai repede decât în restul anului.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        De aceea, programul de lucru trebuie legat de cum funcționează spațiul, nu
                        de un model general. Uneori este mai bine să intervenim înainte de
                        deschidere. Alteori, după închidere, mai ales când este nevoie de o curățare
                        în profunzime a pardoselii sau de lucru atent pe suprafețele vitrate. Sunt
                        și situații în care întreținerea se face pe zone, tocmai ca activitatea să
                        meargă mai departe fără întreruperi.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        La prima vizită ne uităm la ce contează: intrarea, pardoseala, traseele
                        principale, zonele unde se adună urme și intervalele în care spațiul se
                        aglomerează. După aceea stabilim un plan de lucru care are sens pentru
                        locația respectivă.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://i.ibb.co/F4LKx9Ng/Cum-adapt-m-serviciile-de-cur-enie.jpg"
                        alt="Curățenie comercială adaptată programului magazinelor și galeriilor"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} mt={2} color="dark">
                        Cum adaptăm serviciile de curățenie la programul și fluxul magazinului
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Intervenții zilnice, periodice sau în afara orelor de program
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Putem organiza intervenții zilnice, săptămânale, periodice sau în afara
                        programului de funcționare. Pentru unele spații este suficientă o
                        întreținere constantă. Pentru altele, mai ales cele cu trafic mare, este
                        nevoie de verificări mai dese în anumite intervale.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Plan de lucru personalizat pentru fiecare spațiu comercial
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Planul de lucru se stabilește după evaluarea locației. Ținem cont de
                        suprafață, finisaje, trafic, puncte sensibile și program. Așa putem decide
                        ce trebuie făcut frecvent, ce intră în intervențiile periodice și ce merită
                        tratat separat.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Într-un spațiu de retail, anumite lucruri se observă imediat: intrarea,
                        traseul principal, zona caselor de marcat, vitrina, cabinele de probă,
                        grupul sanitar. Dacă aceste puncte sunt ținute bine, tot locul arată altfel.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        La Doral Cleaning, exact la aceste zone ne uităm primele. Venim la locație,
                        vedem unde apar problemele mai repede și stabilim un mod de lucru care poate
                        fi ținut în timp. Fără complicații inutile. Fără operațiuni trecute în plan
                        doar ca să sune bine.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Putem lucra pentru o singură locație sau pentru mai multe puncte de lucru.
                        Iar când ritmul din teren se schimbă, ajustăm și intervențiile.
                    </MKTypography>

                    <MKBox
                        component="img"
                        src="https://doral-cleaning.ro/static/media/11-1-pardoseli.2064539739cdd74c973e.webp"
                        alt="De ce să alegi Doral Cleaning pentru curățenie spații retail"
                        sx={{
                            maxWidth: "100%",
                            width: { xs: "100%", md: "600px" },
                            display: "block",
                            margin: "0 auto",
                        }}
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} mt={2} color="dark">
                        Alege Doral Cleaning pentru curățenia spațiilor din retail
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Echipamente şi soluții profesionale gestionate de un personal instruit
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Folosim utilaje și produse alese după tipul suprafețelor din locație.
                        Mașinile de frecat-aspirat, aspiratoarele profesionale, soluțiile pentru
                        sticlă, detergenții pentru pardoseli și produsele antistatice pentru anumite
                        suprafețe ne ajută să lucrăm corect și eficient. La fel de important este și
                        modul în care sunt folosite, de aceea intervențiile sunt realizate de
                        personal instruit.
                    </MKTypography>

                    {/* H3 */}
                    <MKTypography variant="h3" mb={3} color="dark">
                        Servicii scalabile pentru magazine și galerii comerciale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Putem lucra atât pentru spații mai mici, cât și pentru galerii sau rețele cu
                        mai multe locații. Dacă ai o singură unitate, organizăm intervențiile după
                        nevoile ei. Dacă administrezi mai multe puncte, stabilim pentru fiecare cum
                        se lucrează și ce trebuie urmărit mai atent.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Dacă vrei să vezi ce presupune, în mod real, întreținerea corectă a locației
                        tale, primul pas util este o vizită tehnică. Venim la spațiu, ne uităm la
                        suprafață, la trafic, la tipul pardoselilor, la zonele sensibile și la
                        programul de funcționare. După aceea putem spune clar ce merită făcut
                        frecvent și ce nu are rost să intre într-un plan lunar.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={4}>
                        Uneori este nevoie de intervenții zilnice. Alteori, de un program mai
                        simplu, dar bine pus la punct. Important este să se potrivească felului în
                        care funcționează spațiul tău.
                    </MKTypography>

                    {/* H2 */}
                    <MKTypography variant="h2" mb={3} color="dark">
                        Solicită o ofertă pentru curățenie comercială adaptată magazinului tău
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={6}>
                        Dacă administrezi un magazin, un showroom, o galerie sau mai multe puncte de
                        lucru, putem începe cu o evaluare la locație și o discuție directă despre ce
                        variantă de lucru are sens.
                    </MKTypography>

                    {/* H2 */}
                    <MKTypography variant="h2" mb={4} color="dark">
                        Întrebări frecvente
                    </MKTypography>

                    <MKBox component="ul" pl={4} mb={4}>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Cât de des ar trebui să veniți la noi în locație?</strong>
                            <br />
                            Depinde de trafic, de suprafață și de tipul activității. Într-un spațiu
                            cu rulaj mare, de multe ori este nevoie de întreținere zilnică, iar în
                            anumite perioade și de verificări suplimentare în zonele cele mai
                            expuse.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Puteți veni dimineața devreme sau după ce închidem?</strong>
                            <br />
                            Da. Intervențiile pot fi programate înainte de deschidere, după
                            închidere sau în intervalele în care fluxul de clienți este mai redus.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Spălați și vitrinele?</strong>
                            <br />
                            Da. Putem include și vitrinele, geamurile și alte suprafețe vitrate, fie
                            recurent, fie separat, în funcție de nevoile locației.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Cum calculați prețul pentru un astfel de serviciu?</strong>
                            <br />
                            Prețul nu se ghicește din telefon. Contează cât de mare este spațiul, ce
                            pardoseli are, cât trafic intră zilnic și ce zone trebuie urmărite mai
                            des. După ce vedem locația, putem trimite o oferta de pret.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>
                                Folosiți produse sigure pentru clienți și pentru echipa noastră?
                            </strong>
                            <br />
                            Da. Alegem soluțiile în funcție de tipul suprafețelor și de specificul
                            locației, astfel încât intervenția să fie eficientă și potrivită pentru
                            un mediu comercial folosit zilnic.
                        </MKTypography>
                        <MKTypography component="li" variant="body1" color="text" mb={2}>
                            <strong>Puteți prelua și mai multe locații, nu doar una?</strong>
                            <br />
                            Da. Putem organiza intervențiile pentru o singură unitate sau pentru mai
                            multe puncte de lucru, cu plan de lucru clar și adaptări făcute separat
                            pentru fiecare locație.
                        </MKTypography>
                    </MKBox>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
